<template>
    <div class="table-toolbar">
        <div class="left-actions">
            <a-popover
                placement="bottomLeft"
                trigger="click"
                overlayClassName="view-switcher-popover zero-padding"
                v-model="viewSwitcherVisible"
            >
                <template slot="content">
                    <ViewSwitcher
                        :table="table"
                        @show-view="onShowView"
                        @edit-view="onEditView"
                        @create-new-view="onCreateNewView"
                    />
                </template>
                <SupsisButton primary>
                    {{ currentView ? currentView.name : "Main Table" }}
                    <i class="material-icons">arrow_drop_down</i>
                </SupsisButton>
            </a-popover>
            <!-- Filter butonuna a-popover ekliyoruz -->
            <a-popover
                placement="bottomLeft"
                trigger="click"
                v-model="filterVisible"
                overlayClassName="table-filter-popover"
            >
                <template slot="content">
                    <TableFilter :fields="fields" :value="filters" @input="onFilterChange" />
                </template>
                <SupsisButton :class="{ 'active-filters': filters.length > 0 }">
                    <i class="material-icons">filter_alt</i>
                    {{ $t("tables.filter") }}
                    <span v-if="filters.length > 0" class="filter-count">
                        {{ filters.length }}
                    </span>
                    <i class="material-icons clear-filters" @click.stop="clearFilters" v-if="filters.length">close</i>
                </SupsisButton>
            </a-popover>
            <SupsisButton :class="{ 'active-filters': hiddenFields.length > 0 }" @click="$emit('show-hide-fields')">
                <i class="material-icons">visibility_off</i>
                Hide Fields
                <span v-if="hiddenFields.length > 0" class="filter-count">
                    {{ hiddenFields.length }}
                </span>
                <i
                    class="material-icons clear-filters"
                    @click.stop="$emit('clear-hidden-fields')"
                    v-if="hiddenFields.length > 0"
                    >close</i
                >
            </SupsisButton>
            <SupsisButton @click="openCreateViewModal">
                <i class="material-icons">save</i>
                {{ $t("tables.saveAsView") }}
            </SupsisButton>
            
        </div>
        <div class="right-actions">
            <div class="search-bar">
                <input type="text" :placeholder="$t('tables.search')" @keyup.enter="onSearchEnter" />
                <i class="material-icons">search</i>
            </div>
            <!--            <SupsisButton primary >-->
            <!--                <i class="material-icons">add</i>-->
            <!--                {{ $t("tables.create") }}-->
            <!--            </SupsisButton>-->
            <a-popover trigger="click" placement="bottomRight">
                <template slot="content">
                    <div class="action-menu">
                        <div class="action-item" @click="handleAction('runWebhookAutomation')">
                            <i class="material-icons" style="color: #1890ff">webhook</i>
                            Run Webhook Automation
                        </div>
                        <div class="action-item" @click="handleAction('importRecords')">
                            <i class="material-icons" style="color: #52c41a">upload_file</i>
                            Import Records
                        </div>
                        <div class="action-item" @click="handleAction('downloadAllRecords')">
                            <i class="material-icons" style="color: #faad14">download</i>
                            Download All Records
                        </div>
                        <div
                            class="action-item"
                            :class="{ disabled: !hasSelection }"
                            @click="handleAction('downloadSelectedRecords')"
                        >
                            <i class="material-icons" style="color: #faad14">download</i>
                            {{
                                hasSelection
                                    ? `Download ${selectedRecords.length} Records`
                                    : "Download Selected Records"
                            }}
                        </div>
                        <div
                            class="action-item"
                            :class="{ disabled: !hasSelection }"
                            @click="handleAction('editRecords')"
                        >
                            <i class="material-icons" style="color: #1890ff">edit</i>
                            {{ hasSelection ? `Edit ${selectedRecords.length} Records` : "Edit Records" }}
                            <span class="shortcut"> <kbd>Ctrl</kbd>+<kbd>E</kbd> </span>
                        </div>
                        <div class="action-item" :class="{ disabled: !hasSelection }" @click="confirmDeleteRecords">
                            <i class="material-icons" style="color: #ff4d4f">delete</i>
                            {{ hasSelection ? `Delete ${selectedRecords.length} Records` : "Delete Records" }}
                            <span class="shortcut">
                                <kbd>Backspace</kbd>
                            </span>
                        </div>
                        <div class="action-item" :class="{ disabled: !hasSelection }" @click="confirmDuplicateRecords">
                            <i class="material-icons" style="color: #52c41a">content_copy</i>
                            {{ hasSelection ? `Duplicate ${selectedRecords.length} Records` : "Duplicate Records" }}
                            <span class="shortcut"> <kbd>Ctrl</kbd>+<kbd>D</kbd> </span>
                        </div>
                    </div>
                </template>
                <SupsisButton>
                    <i class="material-icons">more_horiz</i>
                </SupsisButton>
            </a-popover>
            <!-- CreateViewForm'u içeren Modal2 bileşeni -->
            <Modal2 v-if="showCreateViewModal" @cancel="closeCreateViewModal" :showFooter="false" title="Save as View">
                <CreateViewForm
                    :filters="filters"
                    :sort="sort"
                    :search="searchQuery"
                    :hiddenFields="hiddenFields"
                    :lockedFields="lockedFields"
                    @view-created="onViewCreated"
                    @cancel="closeCreateViewModal"
                    :table-id="tableId"
                />
            </Modal2>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";
import TableFilter from "./components/filter/TableFilter.vue";
import { Popover } from "ant-design-vue";
import { message, confirm } from "ant-design-vue";
import { TABLE_API } from "../../../../api/table";
import Modal2 from "../../../../components/common/Modal2.vue";
import CreateViewForm from "./components/CreateViewForm.vue";
import ViewSwitcher from "./components/ViewSwitcher.vue";

export default Vue.extend({
    name: "TableToolbar",
    components: {
        ViewSwitcher,
        SupsisButton,
        TableFilter,
        "a-popover": Popover,
        Modal2,
        CreateViewForm, // Yeni bileşeni ekliyoruz.
    },
    props: {
        fields: {
            type: Array,
            required: true,
        },
        filters: {
            type: Array,
            default: () => [],
        },
        selectedRecords: {
            type: Array,
            default: () => [],
        },
        tableId: {
            type: String,
            required: true,
        },
        hiddenFields: {
            type: Array,
            default: () => [],
        },
        lockedFields: {
            type: Array,
            default: () => [],
        },
        sort: {
            type: Object,
            default: () => ({}),
        },
        table: {
            type: Object,
            required: true,
        },
        currentView: {
            type: Object,
            default: null,
        },
    },
    computed: {
        hasSelection() {
            return this.selectedRecords.length > 0;
        },
    },
    data() {
        return {
            filterVisible: false,
            searchQuery: "",
            showCreateViewModal: false,
            viewSwitcherVisible: false, // Yeni eklendi
        };
    },
    methods: {
        onFilterChange(filters) {
            this.$emit("filter-updated", filters);
        },
        clearFilters() {
            this.$emit("filter-updated", []);
        },
        onSearchEnter(event) {
            this.$emit("search", event.target.value);
        },
        handleAction(action) {
            switch (action) {
                case "editRecords":
                    if (this.hasSelection) {
                        this.$emit("edit-records");
                    }
                    break;
                case "importRecords":
                    this.importRecords();
                    break;
            }
        },
        confirmDeleteRecords() {
            if (!this.hasSelection) return;

            this.$confirm({
                title: "Kayıtları Sil",
                content: `Seçilen ${this.selectedRecords.length} kayıtları silmek istediğinizden emin misiniz?`,
                okText: "Evet",
                okType: "danger",
                cancelText: "Hayır",
                onOk: () => {
                    this.deleteSelectedRecords();
                },
            });
        },
        async deleteSelectedRecords() {
            try {
                await TABLE_API.deleteRecordsByIds(this.tableId, this.selectedRecords);
                this.$emit("records-deleted", this.selectedRecords);
                this.$message.success("Seçilen kayıtlar başarıyla silindi.");
            } catch (error) {
                console.error("Kayıtlar silinirken bir hata oluştu:", error);
                this.$message.error("Kayıtlar silinirken bir hata oluştu.");
            }
        },
        confirmDuplicateRecords() {
            if (!this.hasSelection) return;

            this.$confirm({
                title: "Kayıtları Kopyala",
                content: `Seçilen ${this.selectedRecords.length} kayıtları kopyalamak istediğinizden emin misiniz?`,
                okText: "Evet",
                okType: "primary",
                cancelText: "Hayır",
                onOk: () => {
                    this.duplicateSelectedRecords();
                },
            });
        },
        async duplicateSelectedRecords() {
            try {
                await TABLE_API.duplicateRecords(this.tableId, this.selectedRecords);
                this.$emit("records-duplicated", this.selectedRecords);
                this.$message.success("Seçilen kayıtlar başarıyla kopyalandı.");
            } catch (error) {
                console.error("Kayıtlar kopyalanırken bir hata oluştu:", error);
                this.$message.error("Kayıtlar kopyalanırken bir hata oluştu.");
            }
        },
        handleKeyDown(event) {
            if (!this.hasSelection) return;

            if ((event.ctrlKey || event.metaKey) && event.key === "Backspace") {
                event.preventDefault();
                this.confirmDeleteRecords();
            } else if ((event.ctrlKey || event.metaKey) && event.key === "d") {
                event.preventDefault();
                this.confirmDuplicateRecords();
            } else if ((event.ctrlKey || event.metaKey) && event.key === "e") {
                event.preventDefault();
                this.handleAction("editRecords");
            }
        },
        openCreateViewModal() {
            this.showCreateViewModal = true;
        },
        closeCreateViewModal() {
            this.showCreateViewModal = false;
        },
        onViewCreated(newView) {
            this.$emit("view-created", newView); // Yeni görünümü üst bileşene iletiyoruz.
            this.closeCreateViewModal();
            this.$message.success("Görünüm başarıyla oluşturuldu.");
        },
        onShowView(view) {
            this.viewSwitcherVisible = false;
            this.$emit("show-view", view);
        },
        onEditView(view) {
            this.viewSwitcherVisible = false;
            this.$emit("edit-view", view);
        },
        onCreateNewView() {
            this.showCreateViewModal = true;
            this.viewSwitcherVisible = false; // Popover'ı kapatıyoruz
        },
        importRecords() {
            this.$emit('open-import-modal');
        },
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.handleKeyDown);
    },
});
</script>

<style scoped lang="scss">
.table-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f5f5f5;
}

.left-actions {
    display: flex;
    gap: 10px;
}

.right-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;

    &.btn-primary {
        background-color: #007bff;
        color: #fff;
    }

    &.btn-secondary {
        background-color: #fff;
        color: #333;
        border: 1px solid #ccc;
    }

    .material-icons {
        margin-right: 5px;
    }

    &.dropdown-toggle::after {
        content: "\e5c5";
        font-family: "Material Icons";
        vertical-align: middle;
        margin-left: 5px;
    }
}

.search-bar {
    position: relative;

    input {
        padding: 8px 12px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-size: 14px;
        width: 200px;
    }

    .material-icons {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        color: #999;
    }
}

.active-filters {
    background-color: #1890ff;
    color: white;
}

.filter-count {
    margin-left: 4px;
    background-color: rgba(0, 0, 0, 0.2);
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 12px;
    display: inline-flex;
    align-items: center;

    .clear-filters {
        font-size: 14px;
        margin-left: 2px;
        cursor: pointer;
    }
}

.action-menu {
    display: flex;
    flex-direction: column;

    .action-item {
        display: flex;
        align-items: center;
        padding: 8px 12px;
        cursor: pointer;

        &:hover {
            background-color: #f0f0f0;
        }

        &.disabled {
            cursor: not-allowed;
            color: #ccc;

            .material-icons {
                color: #ccc !important;
            }
        }

        .material-icons {
            margin-right: 8px;
        }

        .shortcut {
            margin-left: 8px;
            color: #999;
            font-size: 12px;

            kbd {
                display: inline-block;
                padding: 2px 4px;
                font-size: 11px;
                line-height: 1;
                color: #666;
                vertical-align: middle;
                background-color: #f7f7f7;
                border: solid 1px #ccc;
                border-bottom-color: #bbb;
                border-radius: 3px;
                box-shadow: inset 0 -1px 0 #bbb;
            }
        }
    }
}
</style>
